'use client';

import {
  ActionIcon,
  Avatar,
  Group,
  Menu,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import MoreVert from '@material-design-icons/svg/filled/more_vert.svg';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

import { useIssuePage } from '@/contexts';
import { Entity_InfoFragment } from '@/graphql';

import styles from './IssueLeaderProfile.module.css';

interface IssueLeaderProfileProps {
  displayLeader: Entity_InfoFragment;
  handleEditIssue: () => void;
  handleSetIssueInactive: () => void;
  isIssueActive: boolean;
}

export const IssueLeaderProfile = ({
  displayLeader,
  handleEditIssue,
  handleSetIssueInactive,
  isIssueActive,
}: IssueLeaderProfileProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const { pageState, isViewModeAsOwner } = useIssuePage();
  const router = useRouter();

  return (
    <Stack gap="xs">
      <Text size="md">Organized by</Text>
      <Stack gap="lg">
        <Group>
          <Group
            gap="md"
            onClick={() => {
              if (displayLeader) {
                router.push(`/profiles/${displayLeader.id}`);
              }
            }}
            className={styles.profileCard}
          >
            <Avatar
              variant="transparent"
              src={displayLeader?.profilePhoto?.link}
              alt={displayLeader?.displayNameLong}
              size="lg"
            />

            <div style={{ flex: 1 }}>
              <Title
                order={3}
                fw={600}
              >
                {displayLeader?.displayNameLong || 'Your Name'}
              </Title>

              <Text
                size="lg"
                fw={400}
              >
                {displayLeader?.bio ||
                  (isViewModeAsOwner(pageState)
                    ? 'Your bio will appear here'
                    : 'No bio provided')}
              </Text>
            </div>
          </Group>

          {isViewModeAsOwner(pageState) && (
            <Menu
              opened={isMenuOpen}
              onClose={() => setIsMenuOpen(false)}
            >
              <Menu.Target>
                <ActionIcon
                  size="xl"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsMenuOpen(true);
                  }}
                  variant="subtle"
                >
                  <MoreVert />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item onClick={handleEditIssue}>Edit</Menu.Item>
                <Menu.Item onClick={handleSetIssueInactive}>
                  {isIssueActive ? 'Unpublish' : 'Publish'}
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          )}
        </Group>
      </Stack>
    </Stack>
  );
};
